import React from 'react'
import {Workflow} from 'yougile-model'
import {Header} from './header'
import {StageActions} from './stage-actions'
import {Props} from './workflow-in-task'

export interface NotInWorkflowProps extends Props {
  workflows: Workflow[]
}

export const NotInWorkflow = (props: NotInWorkflowProps) => {
  const {workflows} = props
  return (
    <>
      {workflows.map(workflow => (
        <div className="mt-8" key={workflow.id}>
          <Header {...{workflow, ...props}} />
          <StageActions {...{workflow, ...props}} stagePath={['start']} />
        </div>
      ))}
    </>
  )
}
